export class NotificationMessage {
  id!: string;
  title!: string;
  body!: string;
  imageUrl!: string;

  data_title!: string;
  data_body!: string;
  data_imageUrl!: string;
  data_button!: string;
  data_linkUrl!: string;

  sysdat!: Date;
  original: any;
  get popupImg(): string {
    return this.imageUrl;
  }
  constructor(data: any) {
    if (data != null) {
      this.id = data.id;
      this.title = data.title;
      this.body = data.body;
      this.imageUrl = data.imageUrl;

      this.data_title = data.data_title;
      this.data_body = data.data_body;
      this.data_imageUrl = data.data_imageUrl;
      this.data_button = data.data_button;
      this.data_linkUrl = data.data_linkUrl;

      this.sysdat = data.sysdat;
      this.original = JSON.stringify(data);
    }
  }
}
